/* __next_internal_client_entry_do_not_use__ variantTagMap,objectToCssString,Align,Truncate,Strikethrough,MaxLines,TypographyStyles auto */ import { Core } from "@faire/design-tokens";
import { css } from "styled-components";
import Color from "../Color";
import { buildResponsiveMediaQueries } from "../Theme/ResponsiveCss";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
import { fontRamp } from "./Themes";
export var variantTagMap = {
    displayXLSerifRegular: "h1",
    displayLSerifRegular: "h2",
    displayMSerifRegular: "h3",
    displaySSansSemiBold: "h4",
    displaySSansRegular: "h4",
    displaySSerifRegular: "h4",
    pageHeaderSerifRegular: "h4",
    sectionHeaderSansMedium: "h5",
    subheadingSansRegular: "h5",
    subheadingSansMedium: "h5",
    paragraphSansRegular: "p",
    paragraphSansMedium: "p",
    labelSansRegular: "p",
    labelSansMedium: "p"
};
export var objectToCssString = function(variant) {
    return variant ? Object.keys(variant).map(function(key) {
        return "".concat(key, ": ").concat(variant[key], ";");
    }).join("") : "";
};
export var Align = function(align) {
    return "text-align: ".concat(align, ";");
};
export var Truncate = "\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n";
export var Strikethrough = "\n  text-decoration: line-through;\n";
export var MaxLines = function(maxLines, lineHeight) {
    return "\n  -webkit-line-clamp: ".concat(maxLines, ";\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  max-height: calc(").concat(lineHeight, " * ").concat(maxLines, "),\n  text-overflow: ellipsis;\n");
};
export var TypographyStyles = function(param) {
    var theme = param.theme, _param_variant = param.variant, variant = _param_variant === void 0 ? "paragraphSansRegular" : _param_variant, _param_color = param.color, color = _param_color === void 0 ? Core.text.default : _param_color, align = param.align, truncate = param.truncate, strikethrough = param.strikethrough, maxLines = param.maxLines;
    var typographyTheme = theme && Object.entries(theme).length !== 0 && theme["typography"] ? theme["typography"] : fontRamp;
    return css([
        "margin:0;padding:0;font-variant-numeric:lining-nums tabular-nums;color:",
        ";",
        " ",
        " ",
        " ",
        " ",
        " ",
        ""
    ], Color[color] || color, buildResponsiveMediaQueries(variant, function(value) {
        return objectToCssString(typographyTheme["fonts"][value]);
    }), align ? buildResponsiveMediaQueries(align, Align) : "", truncate ? Truncate : "", strikethrough ? Strikethrough : "", highVisSlateComponent(HIGH_VIS_FILTER.TYPOGRAPHY), maxLines && maxLines > 0 ? buildResponsiveMediaQueries(variant, function(value) {
        return MaxLines(maxLines, typographyTheme["fonts"][value]["line-height"]);
    }) : "");
};
